import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const DATE_FMT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

export function formatDate(iso: string | null | undefined) {
  if (!iso) return '—'
  return DATE_FMT.format(new Date(`${iso}T00:00:00`))
}

/** Missing data renders as an em dash, never as 0 or an empty cell —
 *  41% of ranks are absent and a blank would read as "unranked". */
export function orDash(v: number | string | null | undefined) {
  return v === null || v === undefined || v === '' ? '—' : String(v)
}

export function formatInt(n: number | null | undefined) {
  return n === null || n === undefined ? '—' : n.toLocaleString('en-GB')
}

export function formatPct(v: number | null | undefined, digits = 0) {
  return v === null || v === undefined ? '—' : `${(v * 100).toFixed(digits)}%`
}

/** Result counts saturate at the API's cap; show "10,000+" rather than a lie. */
export function formatCount(count: number, capped: boolean) {
  return capped ? `${count.toLocaleString('en-GB')}+` : count.toLocaleString('en-GB')
}

export const SURFACE_COLOR: Record<string, string> = {
  clay: 'var(--color-clay)',
  grass: 'var(--color-grass)',
  hard: 'var(--color-hard)',
  carpet: 'var(--color-carpet)',
}
